module.exports = __webpack_public_path__ + "static/media/детокс.64387fda.jpg";